import { IAPIServiceConfigItem } from '../../../../model/api-modules';
import { openURL } from '../../../../lib';
import { useEffect } from 'react';
import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly selectedServiceConfig: IAPIServiceConfigItem;
  readonly url: string;
}

export const IframeJumpComponent = (props: IProps) => {
  const openWebURL = () => {
    openURL(props.url, 'gauth-window');
  };

  useEffect(() => {
    openWebURL();
  }, []);

  return (
    <div className="open-box">
      <div className="iframe-row">
        <div className="icon-box"></div>
        <div className="service-tips">
          {props.selectedServiceConfig.Name}{' '}
          {getFormatMessage('has_been_opened')}
        </div>
      </div>
      <div className="open-tips">
        {getFormatMessage('click_btn_view_server')}
      </div>
      <div className="button-box" onClick={openWebURL}>
        {getFormatMessage('get_started')}
      </div>
    </div>
  );
};
